/** Jet demandé par le MJ : Realtime DB, rollRequest/{campagne}. API modulaire. */
import {getDatabase, ref, set, remove, onValue} from 'firebase/database';
import {normalizeRollRequest} from './rollRequest';

const requestRef = (campaignUid) => ref(getDatabase(), `rollRequest/${campaignUid}`);

/** @returns {Function} désabonnement */
export const watchRollRequest = (campaignUid, onChange) => onValue(requestRef(campaignUid), snapshot => onChange(normalizeRollRequest(snapshot.val())));

/** Remplace la demande en cours. */
export const sendRollRequest = (campaignUid, request) => set(requestRef(campaignUid), request);

export const closeRollRequest = (campaignUid) => remove(requestRef(campaignUid));
